import { applyBLAdvance, blVesselKey } from "./advanceAllocation";
export const SHARED_VESSEL_FIELDS = [
  "vesselName", "shipLine", "etd", "eta", "copyDocReceiveDate",
  "blNo", "blDate", "invoiceNo", "invoiceDate", "freeDetentionDays"
];

const normalize = (value) => String(value || "").trim().toLowerCase();
const isBlank = (value) => value === "" || value === null || value === undefined;
// The deal document is a summary, never a default for individual vessels.
export const readShipmentDocumentFields = (row, formatDate) => ({
  blNo: row.BLNo || "",
  blDate: formatDate(row.BLDate),
  invoiceNo: row.InvoiceNo || "",
  invoiceDate: formatDate(row.InvoiceDate),
  advancePayment: row.AdvancePayment ?? 0,
  invoiceAmount: row.InvoiceAmount ?? 0,
  balanceAmount: row.BalanceAmount ?? 0,
  freeDetentionDays: row.FreeDetentionDays ?? ""
});
export const sameVessel = (a, b) => Boolean(normalize(a.vesselName)) &&
  normalize(a.vesselName) === normalize(b.vesselName) &&
  normalize(a.shipLine) === normalize(b.shipLine);

export const fillMissingVesselDetails = (rows) => rows.map((row) => {
  const next = { ...row };
  for (const field of SHARED_VESSEL_FIELDS) {
    if (isBlank(next[field])) {
      const source = rows.find((candidate) => sameVessel(row, candidate) &&
        (!normalize(row.blNo) || !normalize(candidate.blNo) || normalize(row.blNo) === normalize(candidate.blNo)) &&
        !isBlank(candidate[field]));
      if (source) next[field] = source[field];
    }
  }
  return next;
});

export const updateVesselDetails = (rows, index, updatedRow) => {
  const original = rows[index];
  const shared = Object.fromEntries(SHARED_VESSEL_FIELDS.map((field) => [field, updatedRow[field]]));
  const updated = rows.map((row, rowIndex) => rowIndex === index
    ? updatedRow
    : ((blVesselKey(original) && blVesselKey(row) === blVesselKey(original)) ||
      (sameVessel(row, original) && !normalize(row.blNo))) ? { ...row, ...shared } : row);
  return applyBLAdvance(updated, updatedRow);
};
